import { motion } from "framer-motion";

// Masked line-by-line reveal — wraps children in overflow-hidden, animates inner from y:110% to 0
export const MaskedLine = ({
  children,
  delay = 0,
  duration = 0.9,
  className = "",
  as: Tag = "span",
}) => {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{
          duration,
          delay,
          ease: [0.16, 1, 0.3, 1],
        }}
      >
        {children}
      </motion.span>
    </span>
  );
};

// Scroll-triggered fade + rise
export const FadeUp = ({
  children,
  delay = 0,
  y = 40,
  className = "",
  once = true,
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

// Reveal on scroll — masked line for headings entering viewport.
// whileInView lives on the UNTRANSFORMED wrapper so the IntersectionObserver
// reads the correct position (a transformed child would deadlock detection).
export const MaskedLineOnScroll = ({
  children,
  delay = 0,
  className = "",
}) => {
  return (
    <motion.span
      className="block overflow-hidden"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
    >
      <motion.span
        className={`block ${className}`}
        variants={{ hidden: { y: "115%" }, visible: { y: "0%" } }}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};
